import React from 'react';
import {CBCButton} from 'shared/helpers';
import {
    CancelButtonProps,
    useCancelButton,
} from 'shared/components/CancelButton/helper/useCancelButton';

export const CancelButton = ({
    label = 'Cancel',
    iconName,
    ...props
}: CancelButtonProps) => {
    const {handleCancelClick, dialog} = useCancelButton(props);

    return (
        <>
            <CBCButton
                onClick={handleCancelClick}
                iconName={iconName ? iconName : 'Button-Cancel.svg'}
                className="job-button button-light"
                style={{color: '#8a8080'}}>
                {label}
            </CBCButton>
            {dialog}
        </>
    );
};
